import React, { useEffect, useRef, useState } from 'react';

import { SubtitleSecondary, Paragraph, ButtonMain } from '@components/index';
import { ConfigStorage } from '@config/index';
import { apiRebox, newProviderStorageService } from '@services/index';
import { toastify } from '@utils/notifiers';

import { tableContent, tableResumedContent } from './data';
import PriceItem from './PriceItem';

import {
  Container,
  FormProviderPrice,
  Sections,
  SectionsGroup,
  SectionsItem,
} from './styles';

interface IProps {
  forNewProviderPrice?: {
    advanceStep(): void;
  };
}

const FormProviderNewPrice: React.FC<IProps> = ({ forNewProviderPrice }) => {
  const formRef = useRef(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [services, setServices] = useState<any>({});
  const [prices, setPrices] = useState<any>({});

  const handlePrices = (name: string, value: string, label: string) => {
    setPrices((prevPrices: any) => ({
      ...prevPrices,
      [label]: {
        ...prevPrices[label],
        [name]: Number(value),
      },
    }));
  };

  const submitPrices = async () => {
    try {
      setIsLoading(prevLoading => !prevLoading);
      const servicesAndPricesData = {
        ...services.openingHours,
        ...prices,
        selectedHourType: services.selectedHourType,
      };

      const storagedUser = newProviderStorageService.getProvider(
        ConfigStorage.REBOX_REGISTER_NEW_PROVIDER,
      );
      let id = '';
      if (storagedUser) {
        id = JSON.parse(storagedUser).id;
      }

      for await (const activeService of services.selectedServices) {
        await apiRebox.post('/users/services', {
          users_id: id,
          name: activeService.label,
          ...prices[activeService.label],
          ...services.openingHours,
          hour_type: services.selectedHourType,
        });
      }

      newProviderStorageService.updatePrices(servicesAndPricesData);
      setIsLoading(prevLoading => !prevLoading);
      forNewProviderPrice?.advanceStep();
    } catch (error: any) {
      setIsLoading(prevLoading => !prevLoading);
      toastify(error.message, 'error');
    }
  };

  useEffect(() => {
    let storageServices = newProviderStorageService.getServices(
      ConfigStorage.REBOX_REGISTER_NEW_PROVIDER_SERVICE,
    );
    if (storageServices) {
      storageServices = JSON.parse(storageServices);
      setServices(storageServices);
    }
  }, []);

  return (
    <Container>
      <FormProviderPrice ref={formRef} initialData={[]} onSubmit={submitPrices}>
        <Sections>
          <SectionsGroup>
            {services.selectedServices?.map((service: any) => (
              <SectionsItem key={service.label}>
                <PriceItem
                  tableContent={
                    service.label.includes('reboque')
                      ? tableContent
                      : tableResumedContent
                  }
                  label={service.label}
                  text={service.text}
                  handlePrices={handlePrices}
                />
              </SectionsItem>
            ))}
          </SectionsGroup>
          <ButtonMain
            type="submit"
            loading={isLoading}
            style={{ marginTop: '4vh', maxWidth: 250 }}
          >
            Continuar
          </ButtonMain>
        </Sections>
      </FormProviderPrice>
    </Container>
  );
};

export default FormProviderNewPrice;
